import { FlexContainer } from '~/components/Grid'
import classNames from 'classnames'
import { Button } from '~/components/general/Button'
import { createOptimizedContentfulImage } from '~/libs/contentful/helpers'
import { Asset, AssetFile } from 'contentful'
import { TypeHighlight3Points } from '~/types/contentful'

export const ResumeBuilder = ({
  section,
  isModal,
}: {
  section: TypeHighlight3Points<'WITHOUT_UNRESOLVABLE_LINKS', string>
  isModal?: boolean
}) => {
  const data = section.fields

  const advantagesResumeBuilder = [
    {
      title: data.firstTitle,
      description: data.firstDescription,
      link: { title: data.firstLinkName, url: data.firstLinkUrl },
      backgroundImage: (data.firstIcon as Asset<'WITHOUT_UNRESOLVABLE_LINKS', string>).fields,
    },
    {
      title: data.secondTitle,
      description: data.secondDescription,
      link: { title: data.secondLinkName, url: data.secondLinkUrl },
      backgroundImage: (data.secondIcon as Asset<'WITHOUT_UNRESOLVABLE_LINKS', string>).fields,
    },
    {
      title: data.thirdTitle,
      description: data.thirdDescription,
      link: { title: data.thirdLinkName, url: data.thirdLinkUrl },
      backgroundImage: (data.thirdIcon as Asset<'WITHOUT_UNRESOLVABLE_LINKS', string>).fields,
    },
  ]

  return (
    <>
      <section
        className={classNames(
          'my-25 -mx-8 max-xl:px-11 max-lg:my-15 max-lg:-mx-6 max-md:px-4 max-md:pb-10 max-md:pt-25 max-md:my-0 max-md:-mx-5',
          { 'max-md:py-20 max-md:px-4': isModal },
        )}
        data-block-id={data.blockId ?? ''}
      >
        <FlexContainer
          justify={'between'}
          className="flex-col relative max-lg:gap-6 max-lg:items-center gap-18"
        >
          <FlexContainer
            className={classNames(
              'relative grid grid-cols-3 gap-14 py-2 px-3 max-xl:py-0 max-xl:px-3 max-lg:gap-5 max-md:items-center max-md:grid-cols-1',
              {
                'max-md:gap-10': isModal,
                'max-md:gap-6': !isModal,
              },
            )}
            justify={'between'}
          >
            {advantagesResumeBuilder.map((advantage, idx) => {
              return (
                <div
                  className={classNames(
                    'flex flex-col items-start flex-nowrap w-full gap-7 my-0 mx-auto max-md:flex-row max-md:justify-start max-w-[1120px]',
                    { 'gap-5 max-w-[343px': isModal },
                  )}
                  key={advantage?.title || '' + idx}
                >
                  <div
                    className={classNames({
                      'min-w-18 h-18': isModal,
                    })}
                  >
                    <img
                      className={classNames('block object-contain w-19 h-19 max-md:w-13', {
                        'max-md:w-full object-cover': isModal,
                      })}
                      src={createOptimizedContentfulImage({
                        file: advantage.backgroundImage.file as AssetFile,
                      })}
                      alt=""
                      loading="lazy"
                    />
                  </div>

                  <div
                    className={classNames('grid items-start first:m-0 max-xl:h-full ', {
                      'gap-3 max-w-[243px]': isModal,
                    })}
                  >
                    <h3
                      className={classNames('text-neutral-100 text-m mb-5 max-xl:mb-2', {
                        'is-modal': isModal,
                      })}
                    >
                      {advantage.title}
                    </h3>
                    <p
                      className={classNames('mb-3 lg:mb-6 text-neutral-50 m-0 text-s', {
                        'is-modal text-neutral-100': isModal,
                      })}
                    >
                      {advantage.description}
                    </p>
                    {advantage.link.url && (
                      <Button
                        type={'link'}
                        color={'link'}
                        text={advantage.link.title}
                        href={advantage.link.url}
                        className={'!p-0 !size-fit'}
                      />
                    )}
                  </div>
                </div>
              )
            })}
          </FlexContainer>
        </FlexContainer>
      </section>
    </>
  )
}
